import { useFormik } from 'formik';
import React, { Fragment, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import {
  AddNtxPeoplesContacts,
  clearContactsListByPeopleId,
  GetPeoplesContactsByPeopleId
} from '../../../../store/NTX/Peoples/PeoplesContactSlice';
import { Form } from 'react-bootstrap';
import useLookupTitle from '../../../../hooks/Lookups/use-Lookup-Title';
import { useTranslation } from 'react-i18next';
// import PeoplesContactsList from './PeoplesContactsList';
import CustomAlert from '../../../../components/Shared/Alert/CustomAlert';
import Loading from '../../../../components/Shared/Loader/Loading';
import { Card, CardBody } from '@components/card/card';
import NtxTable from '@components/DataTable/NtxTable';

type Props = {
  peopleId: string | undefined;
};

const PeoplesContacts: React.FC<Props> = ({ peopleId }) => {
  const dispatch = useAppDispatch();
  const { TITLE } = useLookupTitle();
  const { t, i18n } = useTranslation();
  // const Navigate = useNavigate();

  const { PeoplesContactsListByPeopleId } = useAppSelector(state => state.PeoplesContacts);

  
  useEffect(() => {
    dispatch(GetPeoplesContactsByPeopleId(peopleId ?? ''));
    return () => {
      dispatch(clearContactsListByPeopleId());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [peopleId]);

  const { loading, error } = useAppSelector(state => state.PeoplesContacts);

  const formik = useFormik({
    initialValues: {
      id: '',
      peopleId: peopleId,
      peopleSiteId: '',
      title: '',
      name: '',
      name2: '',
      prefix: '',
      phone: '',
      mobile: '',
      department: '',
      emailAddress: '',
      url: '',
      fax: '',
      extraInformationId: ''
    },
    // validationSchema:  ,
    onSubmit: (values, { resetForm }) => {
      dispatch(
        AddNtxPeoplesContacts({
          //   id: "",
          peopleId: peopleId || null,
          // peopleSiteId: null, // values.peopleSiteId ,
          name: values.name,
          name2: values.name2,
          prefix: values.prefix,
          title: values.title,
          phone: values.phone,
          mobile: values.mobile,
          department: values.department,
          emailAddress: values.emailAddress,
          url: values.url,
          fax: values.fax,
          extraInformationId: null
        })
      )
        .unwrap()
        .then(res => {
          // console.log(res);
          // if (res?.succeeded) {
          formik.resetForm();
          CustomAlert({ action: 'Add' });
          // } else {
          formik.setSubmitting(false);
          // CustomAlert({ action: 'Error' });
          // }
        })
        .catch(error => {
          formik.setSubmitting(false);
          CustomAlert({ action: 'Error' });
        });
    }
  });

  // console.log(formik.values);
  
  //____________________________

  const columns = [
    { title: t('Name'), key: 'Name' },
    { title: t('رقم الجوال'), key: 'mobile' },
    { title: t('الهاتف'), key: 'phone' },
    { title: t(''), key: 'action', className: 'text-end' }
  ];

  const tableData = PeoplesContactsListByPeopleId?.map(item => {
    let rowClass;

    return {
      Name: i18n.language === 'ar' ? item.name : item.name2,
      mobile: item.mobile,
      phone: item.phone,
      action: (
        <>
          <button
            type='button'
            className='btn btn-sm btn-outline-theme'
            // onClick={() => setId(item.id)}
          >
            <i className='far fa-lg fa-fw  fa-edit mx-1'></i>
            {t('Button.Edit')}
          </button>
        </>
      ),

      rowClass // استخدم rowClass هنا
    };
  });

  return (
    <Fragment>
      <Loading loading={loading} error={error}>
        <>
          <Card className='mb-3'>
            <CardBody>
              <Form onSubmit={formik.handleSubmit}>
                <div className='row'>
                  <div className='col-xl-6'>
                    <div className='form-group mb-3'>
                      <label className='form-label'>{t('LocalName')}</label>
                      <Form.Control
                        className='form-control text-center'
                        type='text'
                        autoComplete='off'
                        name='name2'
                        onChange={formik.handleChange}
                        value={formik.values.name2}
                        isInvalid={!!(formik.touched.name2 && formik.errors.name2)}
                      />
                    </div>
                  </div>
                  <div className='col-xl-6 '>
                    <div className='form-group mb-3'>
                      <label className='form-label'>{t('GlobalName')}</label>
                      <Form.Control
                        className='form-control text-center'
                        type='text'
                        autoComplete='off'
                        name='name'
                        onChange={formik.handleChange}
                        value={formik.values.name}
                        isInvalid={!!(formik.touched.name && formik.errors.name)}
                      />
                    </div>
                  </div>

                  <div className='col-xl-4'>
                    <div className='form-group mb-3'>
                      <label className='form-label'>{t('Phone')}</label>
                      <Form.Control
                        className='form-control text-center'
                        type='text'
                        autoComplete='off'
                        name='phone'
                        onChange={formik.handleChange}
                        value={formik.values.phone}
                        isInvalid={!!(formik.touched.phone && formik.errors.phone)}
                      />
                    </div>
                  </div>
                  <div className='col-xl-4'>
                    <div className='form-group mb-3'>
                      <label className='form-label'>{t('MobileNumber')}</label>
                      <Form.Control
                        className='form-control text-center'
                        type='text'
                        autoComplete='off'
                        name='mobile'
                        onChange={formik.handleChange}
                        value={formik.values.mobile}
                        isInvalid={!!(formik.touched.mobile && formik.errors.mobile)}
                      />
                    </div>
                  </div>

                  <div className='col-xl-4'>
                    <div className='form-group mb-3'>
                      <label className='form-label'>{t('Email')}</label>
                      <Form.Control
                        className='form-control'
                        type='text'
                        autoComplete='off'
                        name='emailAddress'
                        onChange={formik.handleChange}
                        value={formik.values.emailAddress}
                      />
                    </div>
                  </div>

                
                    <div className='form-group  '>
                      <div className=''>
                        <button disabled={formik.isSubmitting} type='submit' className='btn me-1 btn-theme mb-1'>
                          {formik.isSubmitting ? (
                            <div className='spinner-border spinner-border-sm me-2'></div>
                          ) : (
                            <i className='fas fa-lg fa-fw me-2 fa-plus'></i>
                          )}
                          {t('Add')}
                        </button>
                        <button
                          type='button'
                          className=' btn me-1 btn-default mb-1'
                          data-bs-dismiss='modal'
                          id='closeModalCustomersContacts'
                          // onClick={() => Navigate(-1)}
                        >
                          <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
                        </button>
                      </div>
                    </div>
                  
                </div>
              </Form>
            </CardBody>
          </Card>

          <NtxTable
            data={tableData || []}
            columns={columns}
            dataPerPage={10}
            theadClass=''
            tableClass='table text-nowrap table-hover '
            // enableSearch
            // showRecordsSelector
          />

          {/* <div className=''>{peopleId && <PeoplesContactsList peopleId={peopleId} />}</div> */}
        </>
      </Loading>
    </Fragment>
  );
};

export default PeoplesContacts;
